import { User } from "./user";
import _ from "lodash";

export interface IServiceSpec {
    name: string;
    apisSupported: string;
    basePath: string;
    readRoles: string;
    writeRoles: string;
    createRoles?: string;
    manageRoles?: string;
    mimeTypes?: string[];
    tenant?: string;
}

export interface ServiceFull extends IServiceSpec {
    serviceName: string;
    adapterName: string;
    adapterConfig: any;
}

export interface ServiceDetail {
    name: string;
    documentation: string;
    schema: any;
    apisSupported: string;
    adapterInterface: string;
}

export interface AdapterDetail {
    name: string;
    schema: any;
    interfaces: string[];
}

export interface Catalogue {
    baseSchema: any;
    serviceDetails: { [name: string]: ServiceDetail };
    adapterDetails: { [name: string]: AdapterDetail };
}

export interface UiServices {
    catalogue: Catalogue;
    active: { [basePath: string]: IServiceSpec };
}

export interface ServiceConfig {
    services: { [basePath: string]: ServiceFull };
    domainsServing: string[];
    preSitePipeline: object;
    postSitePipeline: object;
}

export function userInServiceRoles(user: User, serviceRoles: string, path?: string): boolean {
    const reqRoles = serviceRoles.split(' ');
    if (reqRoles.indexOf('all') >= 0) return true;

    const userRolesStr = user && user.roles ? user.roles as string : null;
    if (!userRolesStr) return false;
    let userRoles = userRolesStr.split(' ');

    // e.g. {email} will succeed if the user's email is part of the request path
    // for instance this will let a user access their own record
    const pathMatches = reqRoles
        .filter(r => r.startsWith('{'))
        .map(r => user[r.slice(1, -1)])
        .filter(m => !!m);
    let pathMatch = false;
    if (pathMatches.length) {
        if (path) {
            const pathEls = path.split('/');
            pathMatch = _.intersection(pathMatches, pathEls).length > 0;
        } else {
            pathMatch = true
        }
    }

    return _.intersection(reqRoles, userRoles).length > 0 || pathMatch;
}